import { Link } from "react-router-dom";
import { footerLinks, siteInfo } from "@/mocks/site";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-50">
      <div className="px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2.5">
              <span className="w-11 h-11 rounded-md bg-primary-500 text-background-50 flex items-center justify-center font-heading text-xl font-bold">
                曝
              </span>
              <span className="flex flex-col leading-tight">
                <span className="font-heading text-lg font-bold tracking-wide">直曝</span>
                <span className="text-[11px] text-secondary-200 font-label">网络爆料投稿平台</span>
              </span>
            </div>
            <p className="mt-5 text-sm text-secondary-100/85 leading-relaxed max-w-sm">
              {siteInfo.intro}
            </p>
            <div className="mt-6 space-y-2.5 text-sm font-label">
              <p className="flex items-center gap-2.5">
                <i className="ri-mail-send-line w-5 h-5 flex items-center justify-center text-accent-400" aria-hidden="true"></i>
                <a href={`mailto:${siteInfo.email}`} className="hover:text-accent-300 transition-colors cursor-pointer">
                  {siteInfo.email}
                </a>
              </p>
              <p className="flex items-center gap-2.5">
                <i className="ri-time-line w-5 h-5 flex items-center justify-center text-accent-400" aria-hidden="true"></i>
                <span className="text-secondary-100/85">{siteInfo.workTime}</span>
              </p>
            </div>
          </div>

          <div className="lg:col-span-8 grid grid-cols-1 sm:grid-cols-3 gap-8">
            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-heading font-semibold text-secondary-50 tracking-wide mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <Link
                        to={link.href}
                        className="text-sm text-secondary-100/80 hover:text-accent-300 transition-colors cursor-pointer"
                      >
                        {link.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-700">
        <div className="px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-200/80 font-label">
          <p>© {new Date().getFullYear()} 直曝 · 专注匿名线索收集与内容核查</p>
          <p className="flex items-center gap-2 text-center sm:text-right">
            <i className="ri-shield-check-line w-4 h-4 flex items-center justify-center text-accent-400" aria-hidden="true"></i>
            本站不收集投稿人真实身份信息
          </p>
        </div>
      </div>
    </footer>
  );
}